export default __webpack_public_path__ + "static/media/thumbnail.d6dc5a6c.png";